var varietal_ids = [];
var vintage_ids = [];
var filtering_price = [];

jQuery(document).ready(function ($) {

    /* Smooth anchor scroll */
    $(document).on('click', 'a[href^="#"]', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });


    // TODO: cleanup below.
    var popup_delay = $('#popup_delay').val();
    if ($.cookie("popup") == null) {
        setTimeout(function () {
            $('.pagepopup-container').addClass('modal-show');
            $.cookie("popup", 1, { expires: 1 });
        }, popup_delay * 1000);
    }
    /*********************************************
     * Trade & Media - start
     *********************************************/
    $(".wine-name").on("click", function () {
        if ($("#wine_" + $(this).data('wine_id')).hasClass("expanded"))
            $("#wine_" + $(this).data('wine_id')).removeClass("expanded")
        else {
            $(".wines-group .wine.expanded").removeClass("expanded")
            $("#wine_" + $(this).data('wine_id')).addClass("expanded")
        }
    })
    $(".download-all").on("click", function () {
        url = $(this).data('bottle_shot')
        a = document.createElement('a')
        a.style.display = 'none'
        a.download = ''
        document.body.appendChild(a)
        if (url) {
            a.href = url
            a.click()
            window.URL.revokeObjectURL(url)
        }

        url = $(this).data('shelf_talker')
        if (url) {
            a.href = url
            a.click()
            window.URL.revokeObjectURL(url)
        }

        url = $(this).data('tech_sheet')
        if (url) {
            a.href = url
            a.click()
            window.URL.revokeObjectURL(url)
        }

        url = $(this).data('label')
        if (url) {
            a.href = url
            a.click()
            window.URL.revokeObjectURL(url)
        }
    })

    $(".show-more").on("click", function () {
        $(this).closest(".loading-buttons").siblings(".block-cards").children(".extra-card").removeClass("invisible")
        $(this).closest(".loading-buttons").siblings(".block-cards").children(".extra-card").addClass("visible")
        $(this).siblings(".show-less").css("display", "block")
        $(this).css("display", "none")
    })
    $(".show-less").on("click", function () {
        $(this).closest(".loading-buttons").siblings(".block-cards").children(".extra-card").removeClass("visible")
        $(this).closest(".loading-buttons").siblings(".block-cards").children(".extra-card").addClass("invisible")
        $(this).siblings(".show-more").css("display", "block")
        $(this).css("display", "none")
    })

    /*******************************************
     * Trade & Media - end
     *******************************************/

    /************************
     * compare clubs - start
     ************************/
    $(".club-names .club-name").on("click", function () {
        $(".club-names .club-name").removeClass("active")
        $(this).addClass("active")
        $(".comparing-categories .compare-value.active").removeClass("active")
        $(".comparing-categories .value-" + $(this).data('wine_id')).addClass("active")
    })
    /***********************
    * compare clubs - end
    ************************/

    /*******************************
     * purchase event ticket - start 
     *******************************/
    $(".shop-add-to-cart .button").on("click", function () {
        $(this).closest('.event-atc').find('.v65-widgetProduct-addToCart form:first-child .add-to-cart').click();
        $('.product-modal-img').css({ "background": "url(" + $(this).data("image") + ") no-repeat center", "background-size": "cover", "height": "300px", "margin": "40px", "box-sizing": "border-box" });
        $('.overlay').addClass('modal-show');
    });
    $('.quantity').on("keyup", function () {
        var $this = $(this);
        $this.val($this.val().replace(/[^\d]/g, ''));
        var quantity = $this.val();
        $(this).closest('.event-atc').find('.v65-widgetProduct-addToCart form:first-child .v65-widgetProduct-addToCart-quantity input').val($this.val());
        if ($('.is_sticky').length > 0) {
            $('.quantity').not(this).each(function () {
                $(this).val(quantity);
            });
        }
    });
    /*******************************
     * purchase event ticket - end
     *******************************/

    jQuery("#category-post-content-ajax").hide();
    // $(".photo-gallery.owl-carousel").owlCarousel({
    //     smartSpeed: 650,
    //     nav: false,
    //     autoplay: true,
    //     dots: true,
    //     items: 1,
    //     loop: true,
    //     lazyLoad: true
    // });

    $(".product-modal").hide();
    if ($('.is_category_page').length > 0) {
        ajax_filter_category();
    }
    var rating = parseInt($('.rating-score span').html());
    $('.rating-score span').html(rating.toLocaleString());
    $('.rating-counts span').each(function () {
        var rating_wine = parseInt($(this).html());
        $(this).html(rating_wine.toLocaleString());
    });

    $(document).on('click', '.mobile-filter-popup .icon-close', function () {
        $('.mobile-filter-popup').removeClass('modal-show');
        $('body').removeClass('lock-scroll');
        ajax_filter_category();
    });

    $(document).on("keyup", '.quantity', function (e) {
        var $this = $(this);
        $this.val($this.val().replace(/[^\d]/g, ''));
        var event = $.Event("keyup", { which: e.keyCode });
        console.log(e.keyCode);
        $(this).closest('.product').find('.c7-product__variant .c7-product__variant__add-to-cart input').focus();
        $(this).closest('.product').find('.c7-product__variant .c7-product__variant__add-to-cart input').trigger(event);
        console.log($(this).closest('.product').find('.c7-product__variant .c7-product__variant__add-to-cart input').val());
    });
    $(document).on("keyup", '.per-alternate-quantity', function () {
        var $this = $(this);
        $this.val($this.val().replace(/[^\d]/g, ''));
        $(this).closest('.product').find('.v65-widgetProduct-addToCart form:nth-child(3) .v65-widgetProduct-addToCart-quantity input').val($this.val());
    });
    $(document).on("click", ".add-to-cart-btn.per-bottle", function () {
        $(this).closest('.product').find('.v65-widgetProduct-addToCart form:first-child .add-to-cart').click();
        $('.overlay').addClass('modal-show');
        var str = $('.product-image').html();
        $('.product-modal-img').html(str);
    });
    $('.add-to-cart-btn.per-alternate').click(function () {
        $('.v65-widgetProduct-addToCart form:nth-child(3) .add-to-cart').click();
        $('.overlay').addClass('modal-show');
        var str = $('.product-image').html();
        $('.product-modal-img').html(str);
    });
    $(document).on("click", ".shop-add-to-cart p", function () {
        $(this).closest('.product').find('.c7-product__variant .c7-button').click();
    });
    $(document).on("click", ".shop-case-cart", function () {
        $.ajax({
            type: "GET",
            url: "?addToCart=2015C&quantity=5",
            success: function (res) {
                console.log(res);
            }
        });
    });
    $(document).on("click", ".icon-cart", function () {
        $('.c7-cart__count').click();
    });
    $('.add-to-cart-btn.per-case').click(function () {
        $('.v65-widgetAddToCartCase .add-to-cart').click();
        $('.overlay').addClass('modal-show');

    });
    $('#prick_check').click(function () {
        $('.add-to-cart-form').css({ "display": "flex" });
        $('.per-case').css({ "display": "none" });
        $('.add-to-cart-alternate').css({ "display": "none" });
    });
    $('#case_check').click(function () {
        $('.add-to-cart-form').css({ "display": "none" });
        $('.per-case').css({ "display": "flex" });
        $('.add-to-cart-alternate').css({ "display": "none" });
    });
    $('#alternate_check').click(function () {
        $('.add-to-cart-form').css({ "display": "none" });
        $('.per-case').css({ "display": "none" });
        $('.add-to-cart-alternate').css({ "display": "flex" });
    });
    $('.product-modal .icon-close').click(function () {
        $('.overlay').removeClass('modal-show');
        $('.product-modal').hide();
    });
    $(".overlay").click(function (e) {
        if (!($(event.target).hasClass('product-modal') || $(e.target).parents(".product-modal").length)) {
            $('.product-modal .icon-close').click();
        }
    });
    $('.pagepopup .icon-close').click(function () {
        $('.pagepopup-container').removeClass('modal-show');
    });
    $('.pagepopup .no-thanks').click(function () {
        $('.pagepopup-container').removeClass('modal-show');
    });
    $(".stars-container").each(function (index, element) {
        var str = $(".stars-container").closest(".rating-container").find(".rating-score").html();
        str = str.replace(/\s+/, "");
        var num = parseFloat(str);
        rateStyleJQ(num, element);
    });
    if (!$(".profile").length) {
        $(".toProfile").hide();
    }
    if (!$(".blk__2columns").length) {
        $(".toNotes").hide();
    }
    if (!$(".recipe").length) {
        $(".toParing").hide();
    }
    $(".toSpec").click(function () {
        $("html,body").animate(
            {
                scrollTop: $(".wine-spec-container").offset().top
            },
            800 //speed
        );
    });
    $(".toProfile").click(function () {
        $("html,body").animate(
            {
                scrollTop: $(".profile").offset().top
            },
            800 //speed
        );
    });
    $(".toNotes").click(function () {
        $("html,body").animate(
            {
                scrollTop: $(".blk__2columns").offset().top
            },
            800 //speed
        );
    });
    $(".toParing").click(function () {
        $("html,body").animate(
            {
                scrollTop: $(".recipe").offset().top
            },
            800 //speed
        );
    });
    $(document).on('scroll', function () {
        if ($('.product-anchor-nav').length) {
            if ($(this).scrollTop() >= $('.product-anchor-nav').position().top) {
                if (!$('#menu-btn').is(":checked")) {
                    $('.sticky-product-container').addClass("sticky-scroll");
                }
            }
            else {
                $('.sticky-product-container').removeClass("sticky-scroll");
            }
        }
    });
    var checkLoginWidget = setInterval(function () {
        if (!$('#c7-login').is(':empty')) {
            afterLoginWidgetLoaded();
            clearInterval(checkLoginWidget);
        }
    }, 300);
    function afterLoginWidgetLoaded() {
        if ($('.c7-login__logged-in').length != 0) {
            $('.my-account-name').html($('.c7-login__logged-in').html());
            $('.my-account').show();
            $('.btn-logout').show();
            $('.my-account-name').show();
            $('.my-order').show();
            $('.sign-in').hide();
            $('.sign-up').hide();
            $('.login-widgets').addClass('loggedIn');
        }
        else {
            $('.my-account').hide();
            $('.btn-logout').hide();
            $('.my-account-name').hide();
            $('.my-order').hide();
            $('.sign-in').show();
            $('.sign-up').show();
            $('.login-widgets').removeClass('loggedIn');
        }
    }
    if ($('.c7-buy-variant').length) {
        var addtoCartWidget = setInterval(function () {
            if (!$('.c7-buy-variant').is(':empty')) {
                afterAddtoCartWidgetLoaded();
                clearInterval(addtoCartWidget);
            }
        }, 300);
    }
    function afterAddtoCartWidgetLoaded() {
        const unit = $('.c7-product__variant__price').closest('.c7-buy-variant').data('unit') || 'Bottle';
        $('.c7-product__variant__price').append(`<span class="unit">${unit}</span>`);
    }
    var checkRemoteForm = setInterval(function () {
        if (!$('.c7-form-wrapper').is(':empty')) {
            afterRemoteFormLoaded();
            clearInterval(checkRemoteForm);
        }
    }, 300);
    function afterRemoteFormLoaded() {
        $('.c7-form label').each(function () {
            if ($(this).has('select').length) {
                return;
            }
            $(this).find('input').attr("placeholder", $(this).text());
        });
    }
    var checkViewCart = setInterval(function () {
        if ($('.c7-cart__buttons a:last-child').attr('href') == '/checkout' && $('.c7-cart__buttons a:last-child').html() != 'Checkout') {
            $('.c7-cart__buttons a:last-child').html('Checkout');
        }
        if ($('.c7-account-tile .c7-button-small').attr('href') == '/club') {
            $('.c7-account-tile .c7-button-small').attr('href', '/clubs');
        }
        if ($('.c7-cart__cart-carrot_product_title .c7-button-small').html() != 'Add') {
            $('.c7-cart .c7-cart__close').html('<span class="icon-close"></span>');
            $('.c7-cart__cart-carrot_product_subtitle').html($('.c7-cart__cart-carrot_product .c7-cart-items__price').html());
            $('.c7-cart__cart-carrot_product_title .c7-button-small').html('Add');
        }
    }, 300);

    function rateStyleJQ(num, divID) {
        var ratingRounded = Math.floor(num);
        $(divID).find('.star-over').slice(0, ratingRounded).addClass('star-visible');
        var partialShade = Math.round((num - ratingRounded) * 100);
        if (partialShade != 0) {
            $($(divID).find('.star-over').get(ratingRounded)).addClass('star-visible').css("width", partialShade + "%");
        }
    }
});

// $(window).load(function () {
//     /************************
//      * owl carousel - start
//      ************************/
//     // if (window.innerWidth < 1024) {
//     //     $(".block-cards.owl-carousel").owlCarousel({
//     //         dots: false,
//     //         loop: true,
//     //         stagePadding: 50,
//     //         margin: 10,
//     //         center: true,
//     //         lazyLoad: true,
//     //         responsive: {
//     //             0: {
//     //                 items: 1,
//     //                 nav: false,
//     //                 dots: true
//     //             },
//     //             640: {
//     //                 items: 2,
//     //                 nav: true,
//     //                 dots: true,
//     //                 navText: ['<span class="icon icon-arrow-left"></span>', '<span class="icon icon-arrow-right"></span>'],
//     //             },
//     //             1024: {
//     //                 items: 3,
//     //                 nav: false,
//     //                 loop: false
//     //             }
//     //         }
//     //     });
//     // }
//     /************************
//      * owl carousel - end
//      ************************/
// });

